import React from 'react';

// Lucide chevron geometry (24 viewBox), one path per direction.
// The empty space on the open side of a left/right chevron, in viewBox units: the left
// chevron's path starts at x=9 of 24, and its round cap paints half the stroke before that.
// `chevronSideBearing(size)` is that space at a rendered size, as a CSS calc, so a caller can
// align the painted stroke (not the box) to an edge at any icon size or stroke dial.
const CHEVRON_PATH_START = 9;
const VIEWBOX = 24;
export const chevronSideBearing = (size) =>
  `(${size} * (${CHEVRON_PATH_START} - var(--cs-icon-stroke) / 2) / ${VIEWBOX})`;

const PATHS = {
  down: 'm6 9 6 6 6-6',
  up: 'm18 15-6-6-6 6',
  left: 'm15 18-6-6 6-6',
  right: 'm9 18 6-6-6-6',
};

/**
 * The donor redesign's chevron (SPEC §C Icons): Lucide geometry stroked at the icon-stroke
 * dial. Every donor chevron (selects, Back, disclosure) draws through this, so the glyph
 * cannot drift between surfaces. Size and colour come from `className`. Decorative: the
 * control it sits in carries the name.
 */
export default function Chevron({ direction = 'down', className = '', id }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`[stroke-width:var(--cs-icon-stroke)] ${className}`.trim()}
      id={id}
    >
      <path d={PATHS[direction] || PATHS.down} />
    </svg>
  );
}
